export const DOCKETS_POPUP = 'DOCKETS_POPUP';
export const UPDATE_DOCKETS_PARTS = 'UPDATE_DOCKETS_PARTS';
export const RESET_DOCKETS_PARTS = 'RESET_DOCKETS_PARTS';
export const DOCKETS_FAVORITE_EMAIL = 'DOCKETS_FAVORITE_EMAIL';
export const UPDATE_DOCKET_HEADER = 'UPDATE_DOCKET_HEADER';



/** WEBPACK FOOTER **
 ** ./src/constants/docketsConstants.js
 **/